export const inArray = (state) => Object.values(state.list);
export const inArrayDocs = (state) => Object.values(state.docs);
export const byId = (state) => (id) => state.list[id];
export const parentOrderStatuses = (state) => state.parentOrderStatuses;
